module.exports = __webpack_public_path__ + "img/email.7faac6b8.png";